module.exports = __webpack_public_path__ + "img/hc_pro_eight_4.921d19e3.jpg";